enum AnimationType {
  Default = 'default',
  Less = 'less',
}

export default AnimationType;
